module.exports = __webpack_public_path__ + "static/media/About_660x440px.1f46699e.jpg";